import { Component, input } from '@angular/core';
import { LabelComponent, RootDirective } from '@pure/hive';
import { ContractRenewalRenderInfo } from '../../../../data/models/recommendations.models';
import { registerAsCardPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const CONTRACT_RENEWAL_CARD_PLUGIN_NAME = 'ContractRenewalCardPluginComponent';

/**
 * Plugin component for contract renewal recommendation card body.
 *
 * This component is "plugged into" the RecommendationCardTemplateComponent to provide
 * contract renewal-specific content. The card template provides the shell (header, footer,
 * buttons), while this plugin provides the custom body content.
 *
 * To create a new recommendation type plugin, see: recommendations-container/README.md
 */
@Component({
    selector: 'contract-renewal-card-plugin',
    templateUrl: './contract-renewal-card-plugin.component.html',
    styleUrls: ['./contract-renewal-card-plugin.component.scss'],
    standalone: true,
    imports: [LabelComponent, RootDirective],
})
export class ContractRenewalCardPluginComponent {
    renderInfo = input.required<ContractRenewalRenderInfo>();
}

registerAsCardPlugin(CONTRACT_RENEWAL_CARD_PLUGIN_NAME, ContractRenewalCardPluginComponent);
